/* frontend/src/components/materials/WoodMaterial.js */
import React from 'react';

// Simplified Polished Wood Material
// Returns a single standardized material simulating medium-dark warm brown polished wood.
// Ignores 'type' to ensure uniformity per user request.
const PolishedWoodMaterial = () => (
  <meshStandardMaterial
    color="#8B4513" // SaddleBrown: Medium-dark warm brown
    roughness={0.1} // Low roughness for polished look
    metalness={0.0} // Wood is non-metallic
  />
);

export const WoodMaterial = ({ type }) => {
  return <PolishedWoodMaterial />;
};
